import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler, UIComponentProps } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { MessageViewImpl } from './messageview';
import { MessageCSSStyleImpl } from './messagecss';

export interface MessageComponentProps extends UIComponentProps
{
   messageContent :string;
   onCloseButtonClicked(e:React.MouseEvent):void;
}

export interface MessageComponentHandler extends UIComponentHandler
{
    onCloseButtonClicked(e:React.MouseEvent):void;
}

export class MessageComponent extends UIComponentImpl<MessageComponentProps, UIComponentState, UIDataModel>
{
    constructor(props: MessageComponentProps)
    {
        super(props);
        this.onCloseButtonClicked = this.onCloseButtonClicked.bind(this);

    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MessageViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MessageCSSStyleImpl(applicationContext);
    }

    onCloseButtonClicked(e:React.MouseEvent): void 
    {
        this.props.onCloseButtonClicked(e);
    }   

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/messagecomponent/messagecomponent.tsx